<template>
  <span class="my-menu-item">
    <span class="icon-wrapper">
      <component :is="iconLoader" class="item-icon" :width="20" :height="20" />
    </span>
    <span class="item-text">{{ item.text }}</span>
    <span v-if="count !== undefined" class="item-count">
      {{ count }}
    </span>
  </span>
</template>

<script setup>
  import { computed } from 'vue'
  const MEMU_LIST = [
    {
      type: 'my',
      text: 'MY',
    },
    {
      type: 'login',
      text: '로그인',
    },
    {
      type: 'alarm',
      text: '알림',
    },
    {
      type: 'ticket',
      text: '이용권',
    },
    {
      type: 'coupon',
      text: '쿠폰 등록',
    },
    {
      type: 'profile',
      text: '회원정보 수정',
    },
    {
      type: 'setup',
      text: '성인콘텐츠 설정',
    },
    {
      type: 'logout',
      text: '로그아웃',
    },
  ]
  const props = defineProps({
    type: {
      type: String,
      default: '',
    },
    count: {
      type: Number,
    },
  })

  const iconLoader = computed(() => {
    switch (props.type) {
      case 'my':
        return () => import('../../profile/WProfileImage.vue')
      case 'alarm':
        return () => import('../icon/WMyAlarmIcon.vue')
      case 'ticket':
        return () => import('../icon/WMyTicketIcon.vue')
      case 'coupon':
        return () => import('../icon/WMyCouponIcon.vue')
      case 'profile':
      case 'login':
        return () => import('../icon/WProfileIcon.vue')
      case 'setup':
        return () => import('../icon/WSetupIcon.vue')
      case 'logout':
        return () => import('../icon/WLogoutIcon.vue')
      default:
        return null
    }
  })

  const item = computed(() =>
    MEMU_LIST.find((item) => item.type === props.type),
  )
</script>

<style lang="scss" scoped>
  .my-menu-item {
    display: flex;
    align-items: center;
    width: 100%;
    color: #a5a5a5;
    .icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 20px;
      height: 20px;
    }
    .item-text {
      margin: 0 8px;
      font-size: 14px;
      line-height: 20px;
    }
    .item-count {
      min-width: 20px;
      height: 20px;
      background-color: #252525;
      color: #fff;
      border-radius: 50%;
      font-size: 12px;
      line-height: 20px;
      text-align: center;
    }
    &:hover,
    &:active {
      color: #fff;
    }
  }
</style>
